import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const getApplicationPageContext = React.createContext({});
export let getApplicationPageMachine: any;

const MODULE_NAME = 'machines.getApplication';

export const useSMGetApplications = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getApplicationPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getApplicationPageMachine);

  return {
    getApplicationPageMachine,
    getApplicationPageState: state,
    getApplicationPageSend: send,
  };
};
